import { useParams } from 'react-router-dom';
import { useTaskByIdQuery, useTaskStatusChangeMutation, useTaskUpdateMutation } from 'api';
import { Form } from 'components/index';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import React from 'react';
import { StatusType } from 'components/common/StatusBadge';

export const useGeneral = () => {
  const { taskId } = useParams() as { taskId: string };
  const { data: taskDetails = {} } = useTaskByIdQuery({ id: taskId || '' });
  const [form] = Form.useForm();
  const { handleError, handleSuccess } = useNotificationMessages();
  const [updateTask] = useTaskUpdateMutation();
  const [changeStatus] = useTaskStatusChangeMutation();
  const [editMode, setEditMode] = React.useState(false);

  const onUpdate = React.useCallback(
    async (formData: { description: string; summary: string }) => {
      try {
        const payload = { ...formData, id: taskId };
        const { data, error }: any = await updateTask(payload);
        if (data?.success) {
          handleSuccess('The task details were successfully updated.');
          setEditMode(false);
        } else {
          handleError(error);
        }
      } catch (err) {
        handleError(err);
      }
    },
    [handleSuccess, updateTask, taskId, handleError]
  );

  const handleStatusChange = React.useCallback(
    async (status: StatusType) => {
      try {
        const { data, error }: any = await changeStatus({ taskId, status });
        if (data?.success) {
          handleSuccess('The task status was successfully changed.');
          setEditMode(false);
        } else {
          handleError(error);
        }
      } catch (err) {
        handleError(err);
      }
    },
    [handleSuccess, changeStatus, taskId, handleError]
  );

  return {
    form,
    editMode,
    setEditMode,
    onUpdate,
    handleStatusChange,
    taskDetails,
    taskId,
  };
};
